import * as yup from 'yup';

import Group from 'models/Group';
import { ManagerGroupTypeConfig } from 'models/GroupType';

export function intakeFormValidation() {
  return yup.object().shape({
    name: yup.string().required('Patient name is required'),
    dateOfBirth: yup.date().required('Date of Birth is required'),
    sex: yup
      .object()
      .shape({
        label: yup.string(),
        value: yup.string(),
      })
      .nullable()
      .test('sex', 'Gender is required', (sex) => !!sex?.value),
    physicianTeam: yup
      .object()
      .shape({
        id: yup.string(),
        name: yup.string(),
      })
      .nullable()
      .when('owner', {
        is: (owner: Group | undefined) =>
          (owner?.groupType?.config as ManagerGroupTypeConfig)?.patientPhysicianTeamRequired,
        then: (schema) => schema.test('physicianTeam', 'Physician is required', (obj) => Boolean(obj?.id)),
        otherwise: (schema) => schema.notRequired(),
      }),
    owner: yup
      .object()
      .shape({
        id: yup.string(),
        name: yup.string(),
      })
      .nullable()
      .test('owner', 'Managed By is required', (obj) => Boolean(obj?.id)),
    transferredFrom: yup
      .object()
      .shape({
        id: yup.string(),
        name: yup.string(),
      })
      .nullable()
      .when('owner', {
        is: (owner: Group | undefined) =>
          (owner?.groupType?.config as ManagerGroupTypeConfig)?.patientTransferredFromRequired,
        then: (schema) => schema.test('transferredFrom', 'Hospital is required', (obj) => Boolean(obj?.id)),
        otherwise: (schema) => schema.notRequired(),
      }),
    group: yup
      .object()
      .shape({
        id: yup.string(),
        name: yup.string(),
      })
      .nullable()
      .test(
        'group',
        (obj, context) =>
          Boolean(obj?.id) ||
          context.createError({ message: `${context.parent.locationType?.label || 'Provider'} is required` })
      ),
  });
}
